/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_Property_TypeInputs */

const cs_public_site_demand_property_type = /** @type {(inputs: Public_Site_Demand_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ nemovitosti`)
};

const en_public_site_demand_property_type = /** @type {(inputs: Public_Site_Demand_Property_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property type`)
};

/**
* | output |
* | --- |
* | "Property type" |
*
* @param {Public_Site_Demand_Property_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_property_type = /** @type {((inputs?: Public_Site_Demand_Property_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_Property_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_property_type(inputs)
	return cs_public_site_demand_property_type(inputs)
});